// components/HeroSection.js
import React from 'react';
import '../styles/HeroSection.css';

function HeroSectionENG() {
  const handleCTAClick = () => {
    // Scroll to about section or handle registration
    const aboutSection = document.querySelector('.about-section');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (

    <div className="hero-image-wrapper">
<img
src="/images/1ENG.png"
alt="Event poster wide"
className="hero-image"
/>
</div>

  );
}

export default HeroSectionENG;
